export default "assets/images/quote-5de51dc5.svg";